module.exports = __webpack_public_path__ + "static/media/1.3.69b4bf08.png";